import React from 'react';
import { Section, Container } from '../../common/UI';
import ContactForm from './ContactForm';
import ContactInfo from './ContactInfo';
import SocialLinks from './SocialLinks';

const Contact = () => {
  return (
    <Section id="contact" background="default" padding="default">
      <Container>
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">
            Get In Touch
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            Have a project in mind or want to collaborate? I'd love to hear from you. 
            Let's build something amazing together!
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Contact Information */}
          <div className="space-y-8">
            <ContactInfo />
            <SocialLinks />
            
            {/* Additional Contact Options */}
            <div className="bg-gradient-to-br from-blue-50 to-purple-50 dark:from-gray-800 dark:to-gray-700 p-8 rounded-xl border border-gray-200 dark:border-gray-600">
              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
                💡 Looking for collaboration?
              </h3>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                I'm always open to discussing new opportunities, interesting projects, 
                or just having a chat about technology and development.
              </p>
              <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
                <div>✨ Available for freelance projects</div>
                <div>🚀 Open to full-time opportunities</div>
                <div>🤝 Interested in collaborations</div>
                <div>💬 Happy to provide mentorship</div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div>
            <ContactForm />
          </div>
        </div>
      </Container>
    </Section>
  );
};

export default Contact;